import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
  selector: 'app-hr-date-list',
  templateUrl: './../../../templates/forms/modals/hr-date-list.component.html'
})
export class HrDateListComponent implements OnInit {

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrDateListId"

  dateList: any[] = [];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.salaryDateRange, field: 'RANGE', sortable: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.load('FG_HR_COMM_SALARY_PROC_RANGE').subscribe(results => {
      this.dateList = results.body;
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }

}
